import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function TikTokIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'TikTok',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>TikTok</title>
			<rect width="40" height="40" rx="8" fill={bg} />
			<g transform="translate(3.4 3.4) scale(0.065)">
				<path
					d="M347.7 17.8c8.2 70.4 47.5 112.4 115.7 116.8v79.1c-39.6 3.9-74.2-9.1-114.6-33.4v148c.3 193.1-207.4 207.8-266.8 112-39.5-63.7-25.2-216.7 117.3-239.4v80.4c-33.3 5.5-51.3 15.7-61.2 34.6-61.1 116.8 152 186.3 137.2-1.9V17.8z"
					fill={g}
				/>
			</g>
		</svg>
	);
}
